import * as angular from 'angular';
import * as _ from 'lodash';
import ComponentController from '../../../common/components/component-controller';
var templateUrl = require('./users.html');

class UsersController extends ComponentController {
  users: any[];
  canCreate: boolean;

  constructor(private $state: any, private UserService: any, private AuthService: any) {
    super();
  }

  $onInit() {
    this.canCreate = this.AuthService.hasPermission('User', 'create');
  }

  goToUserDetail($event, userId) {
    this.stopProp($event);
    this.$state.go('admin.user-detail', { userId: userId });
  }
}

angular.module('ciApp').component('users', {
  templateUrl: templateUrl,
  bindings: {
    users: '<'
  },
  controller: ['$state', 'UserService', 'AuthService', UsersController]
});



// WEBPACK FOOTER //
// ./app/admin/users/users.component.ts